var _a, _b;
import { X_AXIS, Y_AXIS } from './types';
export var OFFSET_CALCULATORS = {
    x: (_a = {},
        _a[X_AXIS.outsideLeft] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.left - popoverRect.width - portalPosition.left + offset.left;
        },
        _a[X_AXIS.outsideRight] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.left + targetRect.width - portalPosition.left + offset.left;
        },
        _a[X_AXIS.middle] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.left +
                targetRect.width / 2 -
                popoverRect.width / 2 -
                portalPosition.left +
                offset.left);
        },
        _a[X_AXIS.insideLeft] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.left - portalPosition.left + offset.left;
        },
        _a[X_AXIS.insideRight] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.left +
                targetRect.width -
                popoverRect.width -
                portalPosition.left +
                offset.left);
        },
        _a),
    y: (_b = {},
        _b[Y_AXIS.outsideTop] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.top - popoverRect.height - portalPosition.top + offset.top;
        },
        _b[Y_AXIS.outsideBottom] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.top + targetRect.height - portalPosition.top + offset.top;
        },
        _b[Y_AXIS.middle] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.top +
                targetRect.height / 2 -
                popoverRect.height / 2 -
                portalPosition.top +
                offset.top);
        },
        _b[Y_AXIS.insideTop] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.top - portalPosition.top + offset.top;
        },
        _b[Y_AXIS.insideBottom] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.top +
                targetRect.height -
                popoverRect.height +
                -portalPosition.top +
                offset.top);
        },
        _b)
};
//# sourceMappingURL=calculators.js.map